export default {
  data: '/admin/api/users',
  export: '/admin/api/users/export',
  deletePrecheck: '/admin/api/users/delete-check'
};
